import RouteView from '@/layouts/RouteView'
import MenuView from '@/layouts/MenuView'

const lazyChannel = {
  channelRouter: [
    {
      path: '/index',
      name: '首页',
      component: MenuView,
      redirect: '/login',
      icon: 'none',
      invisible: true,
      children: [
        {
          path: '/dashboard',
          name: '首页',
          component: RouteView,
          icon: 'home',
          children: [
            {
              path: '/dashboard/Analysis',
              name: '首页',
              component: () => import('@/pages/dashboard/Analysis'),
              icon: 'none'
            },
            {
              path: '/dashboard/BasicAccountingInformation',
              name: '账务基础信息',
              component: () => import('@/pages/dashboard/BasicAccountingInformation'),
              invisible: true,
              icon: 'none'
            },
            {
              path: '/dashboard/NoticeInfo',
              name: '公告信息',
              component: () => import('@/pages/dashboard/NoticeInfo'),
              invisible: true,
              icon: 'none'
            },
            {
              path: '/dashboard/TodayOrderDetails',
              name: '今日订购信息',
              component: () => import('@/pages/dashboard/TodayOrderDetails'),
              invisible: true,
              icon: 'none'
            },
            {
              path: '/dashboard/DetailsTodayOrder',
              name: '今日订购详情',
              component: () => import('@/pages/dashboard/DetailsTodayOrder'),
              invisible: true,
              icon: 'none'
            },
            {
              path: '/dashboard/MonthOrderDetails',
              name: '本月订购信息',
              component: () => import('@/pages/dashboard/MonthOrderDetails'),
              invisible: true,
              icon: 'none'
            },
          ]
        },
        {
          path: '/enterprise',
          name: '企业管理',
          icon: 'bank',
          component: RouteView,
          children: [
            {
              path: '/enterprise/Basic',
              name: '基本信息',
              icon: 'none',
              component: () => import('@/pages/enterprise/Basic')
            },
            {
              path: '/enterprise/Contracts',
              name: '合同信息',
              icon: 'none',
              component: () => import('@/pages/enterprise/Contracts')
            }
          ]
        },
        {
          path: '/order',
          name: '订购管理',
          icon: 'pay-circle',
          component: RouteView,
          children: [
            {
              path: '/order/OrderWayInfo',
              name: '交付方式',
              icon: 'none',
              component: () => import('@/pages/order/OrderWayInfo')
            },
            {
              path: '/order/OrderWayProduct',
              name: '交付产品',
              icon: 'none',
              component: () => import('@/pages/order/OrderWayProduct')
            },
          ]
        },
        {
          path: '/accounts',
          name: '财务管理',
          icon: 'calculator',
          component: RouteView,
          children: [
            {
              path: '/accounts/ChannelCharges',
              name: '交易明细',
              icon: 'none',
              component: () => import('@/pages/accounts/ChannelCharges')
            },
          ]
        },
        {
          path: '/channel',
          name: '代理商信息',
          icon: 'exception',
          component: RouteView,
          children: [
            {
              path: '/channel/Channel',
              name: '代理商基本信息',
              icon: 'none',
              component: () => import('@/pages/channel/Channel')
            },
            {
              path: '/channel/ChannelContracts',
              name: '代理商合同信息',
              icon: 'none',
              component: () => import('@/pages/channel/ChannelContracts')
            },
            {
              path: '/channel/DemoList',
              name: '例子',
              icon: 'none',
              invisible: true,
              component: () => import('@/pages/channel/DemoList')
            },
          ]
        },
        {
          path: '/channelresource',
          name: '代理商资源',
          icon: 'book',
          component: RouteView,
          children: [
            {
              path: '/channelresource/ChannelOrderWayInfo',
              name: '交付方式',
              icon: 'none',
              component: () => import('@/pages/channelresource/ChannelOrderWayInfo')
            },
            {
              path: '/channelresource/ChannelOrderWayProduct',
              name: '交付产品',
              icon: 'none',
              component: () => import('@/pages/channelresource/ChannelOrderWayProduct')
            },
            {
              path: '/channelresource/ChannelProduct',
              name: '产品配置',
              icon: 'none',
              invisible: true,
              component: () => import('@/pages/channelresource/ChannelProduct')
            }
          ]
        },
        {
          path: '/channelaccounts',
          name: '代理商账务',
          icon: 'red-envelope',
          component: RouteView,
          children: [
            {
              path: '/channelaccounts/Accounts',
              name: '账户信息',
              icon: 'none',
              component: () => import('@/pages/channelaccounts/Accounts')
            },
            {
              path: '/channelaccounts/Charge',
              name: '交易明细',
              icon: 'none',
              component: () => import('@/pages/channelaccounts/Charge')
            },
            {
              path: '/channelaccounts/DayBill',
              name: '日账单',
              icon: 'none',
              component: () => import('@/pages/channelaccounts/DayBill')
            },
            {
              path: '/channelaccounts/MonthBill',
              name: '月账单',
              icon: 'none',
              component: () => import('@/pages/channelaccounts/MonthBill')
            },
          ]
        },
        {
          path: '/OrderQuery',
          name: '订购查询',
          icon: 'profile',
          component: RouteView,
          children: [
            {
              path: '/OrderQuery/APIOrderQuery',
              name: 'API订购查询',
              icon: 'none',
              component: () => import('@/pages/OrderQuery/APIOrderQuery')
            },
            {
              path: '/OrderQuery/OnlineOrderQuery',
              name: '在线订购查询',
              icon: 'none',
              component: () => import('@/pages/OrderQuery/OnlineOrderQuery')
            },
            {
              path: '/OrderQuery/DoOrderInfo',
              name: '文件订购详情',
              icon: 'none',
              invisible: true,
              component: () => import('@/pages/OrderQuery/DoOrderInfo')
            },
          ]
        },
        {
          path: '/Console',
          name: '我的控制台',
          icon: 'profile',
          component: RouteView,
          children: [
            {
              path: '/Console/BusinessApply',
              name: '业务申请',
              icon: 'none',
              component: () => import('@/pages/Console/BusinessApply'),
            },
            {
              path: '/Console/MyTask',
              name: '我的任务',
              icon: 'none',
              component: () => import('@/pages/Console/MyTask'),
            },
            {
              path: '/Console/Detail:parameter',
              name: '详情',
              icon: 'none',
              component: () => import('@/pages/Console/Detail'),
              invisible: true,
            },
            {
              path: '/Console/ProcessInstance',
              name: '流程实例',
              icon: 'none',
              component: () => import('@/pages/Console/ProcessInstance'),
            },
          ],
        },
      ],
    },
  ],
};

export default lazyChannel






// WEBPACK FOOTER //
// ./src/router/lazyChannel.js